function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import Boundable from './Boundable';
import ArrayList from '../../../../../java/util/ArrayList';
import Serializable from '../../../../../java/io/Serializable';
import Assert from '../../util/Assert';
var AbstractNode = /*#__PURE__*/function () {
  function AbstractNode() {
    _classCallCheck(this, AbstractNode);
    AbstractNode.constructor_.apply(this, arguments);
  }
  return _createClass(AbstractNode, [{
    key: "getLevel",
    value: function getLevel() {
      return this._level;
    }
  }, {
    key: "size",
    value: function size() {
      return this._childBoundables.size();
    }
  }, {
    key: "getChildBoundables",
    value: function getChildBoundables() {
      return this._childBoundables;
    }
  }, {
    key: "addChildBoundable",
    value: function addChildBoundable(childBoundable) {
      Assert.isTrue(this._bounds === null);
      this._childBoundables.add(childBoundable);
    }
  }, {
    key: "isEmpty",
    value: function isEmpty() {
      return this._childBoundables.isEmpty();
    }
  }, {
    key: "getBounds",
    value: function getBounds() {
      if (this._bounds === null) {
        this._bounds = this.computeBounds();
      }
      return this._bounds;
    }
  }, {
    key: "getClass",
    value: function getClass() {
      return AbstractNode;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [Boundable, Serializable];
    }
  }]);
}();
export { AbstractNode as default };
AbstractNode.constructor_ = function () {
  this._childBoundables = new ArrayList();
  this._bounds = null;
  this._level = null;
  if (arguments.length === 0) {} else if (arguments.length === 1) {
    var level = arguments[0];
    this._level = level;
  }
};
AbstractNode.serialVersionUID = 6493722185909573708;